import React from 'react';

var _path;

var SvgCollectionsMajor = function SvgCollectionsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.948.001C7.342.001 7.72.16 8 .44l1.477 1.68-3.638 4.12a3.568 3.568 0 0 0-.872 2.33V18h-2.48a1.48 1.48 0 0 1-1.051-.44A1.507 1.507 0 0 1 1 16.5V6.62a1.497 1.497 0 0 1 .377-1l3.48-4L5.897.44A1.48 1.48 0 0 1 6.949.001zM14.04 2.44l4.58 5.13c.247.275.383.631.381 1v9.93c0 .399-.159.78-.441 1.062a1.51 1.51 0 0 1-1.065.439H8.456a1.509 1.509 0 0 1-1.033-.457A1.497 1.497 0 0 1 7 18.5V8.62a1.487 1.487 0 0 1 .382-1l3.524-4.001 1.005-1.18a1.51 1.51 0 0 1 2.128 0zm-1.9 5.807a1.51 1.51 0 0 0 1.901-.186 1.497 1.497 0 0 0-.489-2.447 1.512 1.512 0 0 0-1.641.325 1.498 1.498 0 0 0 .228 2.308z"
  })));
};

export { SvgCollectionsMajor as S };
